import styled from 'astroturf/react';

const Box = styled('div')`
  position: relative;
  z-index: 10;
  box-shadow: var(--ph-box-shadow-sm);
  background-color: var(--white);
  display: flex;
  width: 100%;
  min-height: 100%;
  flex-direction: row;
  margin-bottom: 20px;

  &.halfWidth {
    width: 50%;
    min-width: 500px;
  }

  &.wide {
    width: 100%;
    min-width: 500px;
  }

  &.semiWidth {
    width: 60%;
    padding-right: 40px;
  }

  &.fullwidth {
    box-shadow: none;
    border-radius: 0;
    margin-top: 30px;
    left: -48px;
    width: calc(100% + 120px);
    position: absolute;
    min-height: calc(100% - 86px);
    margin-bottom: 0;
  }

  &.fullWidth2 {
    box-shadow: none;
    border-radius: 0;
    margin-top: 30px;
    width: 100%;
    position: absolute;
    min-height: calc(100% - 86px);
    margin-bottom: 0;
  }

  &.active {
    box-shadow: 0 0 0 2px var(--ph-light-blue-500) inset;

    div[class*='rc-tabs-top'] {
      margin: 0 -20px 0 -20px;
    }
  }

  &.withoutBorder {
    border: none;
    box-shadow: none;
  }

  &.stickyContainer {
    display: block;
  }
`;

const BoxCol = styled('div')`
  flex: 1;
  width: 100%;

  & + & {
    width: 50%;
  }

  &.isSticky {
    position: sticky;
    top: -25px;
    height: 90vh;
  }

  &.isInlineBlock {
    display: inline-block;
    width: 50%;
    vertical-align: top;
  }
`;

export default { Box, BoxCol };
